// Centralized portfolio data - Media Agency Projects
export const portfolioData = [
    {
        id: 'tv-campaign-billions',
        title: 'Campagne TV - Billions',
        description: 'Une campagne publicitaire télévisée innovante pour la marque Billions, combinant stratégie média optimisée et création audiovisuelle percutante pour maximiser la portée et l\'engagement.',
        shortDescription: 'Campagne publicitaire télévisée avec stratégie média optimisée et création audiovisuelle percutante.',
        features: [
            'Achat d\'espaces TV multi-chaînes',
            'Production de spots publicitaires',
            'Stratégie de diffusion optimisée',
            'Analyse de performance en temps réel',
            'ROI mesuré et optimisé',
            'Couverture médiatique étendue'
        ],
        icon: '📺',
        imageId: 1015, // Unsplash image ID for advertising/tv
        supports: ['TV', 'Digital Display', 'Production Audiovisuelle', 'Analyse de données'],
        alignment: 'left'
    },
    {
        id: 'digital-campaign-bloom',
        title: 'Campagne Digital - Bloom Media France',
        description: 'Stratégie complète de marketing digital pour Bloom Media France incluant gestion des réseaux sociaux, campagnes publicitaires en ligne, SEO/SEA et création de contenu graphique personnalisé.',
        shortDescription: 'Stratégie complète de marketing digital avec gestion réseaux sociaux, campagnes en ligne et création de contenu.',
        features: [
            'Gestion des réseaux sociaux',
            'Campagnes publicitaires en ligne',
            'SEO & SEA optimisés',
            'Création de contenu graphique',
            'Planification de publication',
            'Mesure de performance ROI'
        ],
        icon: '💻',
        imageId: 1076, // Unsplash image ID for digital marketing
        supports: ['Social Media', 'Display Advertising', 'SEO/SEA', 'Design & Créativité'],
        alignment: 'right'
    },
    {
        id: 'event-production-mediterranean',
        title: 'Production Événementielle - Mediterranean Export',
        description: 'Organisation complète d\'un événement corporate pour Mediterranean Export, incluant la production audiovisuelle, la scénographie, les technologies innovantes et la couverture médiatique.',
        shortDescription: 'Organisation complète d\'événement corporate avec production audiovisuelle et technologies innovantes.',
        features: [
            'Organisation d\'événement corporate',
            'Production audiovisuelle sur-mesure',
            'Scénographie et design événementiel',
            'Technologies interactives',
            'Couverture médiatique complète',
            'Mesure de performance événement'
        ],
        icon: '🎪',
        imageId: 1690, // Unsplash image ID for events
        supports: ['Événementielle', 'Production Audiovisuelle', 'Design & Créativité', 'PR'],
        alignment: 'left'
    },
    {
        id: 'influence-campaign-andalou',
        title: 'Campagne Influence - Andalou Arabesque',
        description: 'Stratégie de marketing d\'influence pour Andalou Arabesque avec sélection stratégique d\'influenceurs, création de contenus uniques et mesure transparente du ROI pour maximiser l\'impact de la marque.',
        shortDescription: 'Stratégie de marketing d\'influence avec sélection d\'influenceurs et création de contenus uniques.',
        features: [
            'Sélection stratégique d\'influenceurs',
            'Création de contenus uniques',
            'Scripts et copyright personnalisés',
            'Mesure transparente du ROI',
            'Optimisation des performances',
            'Suivi multi-plateformes'
        ],
        icon: '📱',
        imageId: 1527, // Unsplash image ID for influencer marketing
        supports: ['Influence Marketing', 'Social Media', 'Création de contenu', 'Analyse de données'],
        alignment: 'right'
    }
];

export default portfolioData;
